/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define([
  "client/template",
  "client/templateregistry",
  "component!base",
  "i18n/i18n",
  "underscore",
  "jquery",
  "api/chat/v1beta/data",
  "utils/sourceinfo",
  "utils/dom",
  "utils/clone",
  "utils/lzma-url",
  "utils/window",
  "utils/app"
], function(
  Template,
  TemplateRegistry,
  ComponentBase,
  i18n,
  _,
  $,
  DataChannel,
  SourceInfoUtil,
  dom,
  deepClone,
  Lzma,
  WindowUtility,
  AppUtils
) {
  var DataCollection = new DataChannel.DataCollection();
  var ChatTemplate = Template.extend({
    editableName: "editor_chatframe",

    schema: new Template.Schema({
      attributes: {
        constraint: {
          type: "QueryExpr",
          title: "editor_chat_constraint"
        },
        height: {
          type: "string",
          title: "editor_chat_height",
          default: "auto",
          values: [
            { value: "auto", text: i18n("editor_chat_automatic_view") },
            { value: "95vh", text: i18n("editor_chat_full_view") },
            { value: "75vh", text: i18n("editor_chat_third_view") },
            { value: "50vh", text: i18n("editor_chat_half_view") },
            { value: "25vh", text: i18n("editor_chat_quarter_view") }
          ]
        },
        "show-model": {
          title: "editor_show_chat_model",
          type: "boolean",
          default: true
        },
        "show-side-navigation": {
          title: "editor_show_chat_conversation",
          type: "boolean",
          default: true
        },
        "use-user-query": {
          title: "editor_chat_use_user_query",
          type: "boolean",
          default: true
        },
        "use-user-constraints": {
          title: "editor_chat_use_user_constraints",
          type: "boolean",
          default: true
        },
        "use-source-context-constraints": {
          title: "editor_chat_use_source_context_constraints",
          type: "boolean",
          default: true
        },
        "model-id": {
          type: "string",
          title: "editor_chat_modelid",
          visible: false
        }
      }
    }),

    hasContent: function() {
      return true;
    },

    getContentSchema: function() {
      return {
        type: "template"
      };
    },

    getOptions: function(options) {
      this.useCamelCaseNames = true;
      // @todo the merge process in initActions need the properties here
      // @workaround this.get() returns the attribute model as an object
      // options should be string so the parseAttributes will chnage them to object if needed
      var attrs = this.get();
      var newAtts = {};
      if (attrs.modelId) {
        newAtts.modelId = attrs.modelId;
      }
      if (attrs.constraint) {
        newAtts.constraint = attrs.constraint;
        if (attrs.constraint.unparsed) {
          newAtts.constraint = attrs.constraint.unparsed;
        } else {
          try {
            newAtts.constraint = JSON.stringify(attrs.constraint);
          } catch (error) {
            console.warn("QueryExpresion parsed failed.");
            newAtts.constraint = "";
          }
        }
      }

      options = _.extend(
        {},
        Template.prototype.getOptions.apply(this, arguments),
        this.attributeModel.getCamelCase(),
        newAtts
      );
      return this.schema.parseAttributes(options);
    },

    remove: function(options) {
      $(this.el).empty();
      DataCollection.off();
    }
  });

  ChatTemplate.View = ComponentBase.extend({
    initialize: function() {
      ComponentBase.prototype.initialize.apply(this, arguments);
      var onError = this.onError.bind(this);
      DataCollection.on("add", this.appendIframe, this);
      DataCollection.fetch(
        this.defaultChannel(),
        this.options.application.options,
        this.options.application.channelOptions,
        onError
      );
      var sendRetrivalOptionsToChatIframe = this.sendRetrivalOptionsToChatIframe.bind(this);

      this.model.listenTo(this.model.input, "change", sendRetrivalOptionsToChatIframe);
      
      this.registerChatFrameListener();
      var rootEls = this.options.application.rootEls;
      var rootEl = AppUtils.getRootElement(rootEls, this.el);
      const viewportElement = this.options.application.options.viewportElement || rootEl;
      this.windowUtility = new WindowUtility({viewportElement: viewportElement , el : this.el , height: this.options.height});
      this.resizeCallBack = this.resize.bind(this);
      if (this.options.height === "auto") {
        $(window).on("resize", this.resizeCallBack);
      }
      var removeEventHandlers = this.removeEventHandlers.bind(this);
      this.listenTo(this.options.application, "destroy", removeEventHandlers);
      $(this.el).addClass("mb-chatframe-height");
      var newHeight = this.windowUtility.sanitizeHeightValue(this.options.height);
      if (newHeight && this.options.height !== "auto") {
        $(this.el).css("height", "");
          $(this.el).css("height", newHeight);
      } else {
        this.resize();
      }
    },

    resize : function(){
      this.windowUtility.resizeToBottom();
    },

    defaultChannel: function() {
      //@todo check if there is any other way !
      // defaultChannel is not working if the sources set via application options
      // return this.options.application.models.defaultChannels.at(0).get('url') + "../..";
      return this.options.application.channels.at(0).get("url") + "../..";
    },

    appendIframe: function(error) {
      if (error && error.status && error.status !== 200) {
        this.appendErrorMessage(error);
      } else {
        this.removeErrorMessage();
      }

      if (!this.hasIframe()) {
        this.$chatIframe = $("<iframe />");
        this.$chatIframe.addClass("mb-chatiframe");
        $(this.el).append(this.$chatIframe);
      }

      this.updateIframeLocation();
    },

    updateIframeLocation: function() {
      if (!this.hasIframe()) {
        return;
      }
      var aiChatPath = this.getIframeSrc();
      var url = new URL(aiChatPath);
      url = this.setParamLanguage(url);
      url = this.setParamShowModelSetting(url);
      url = this.setParamShowSideNavigationSetting(url);
      var retrievalOptions = this.getRetrivalOptionsAsUrlParam();
      if (retrievalOptions) {
        url.searchParams.set("retrieval_options", retrievalOptions);
      }
      this.$chatIframe.attr('src', url);
    },

    onError: function(error) {
      this.appendIframe(error);
    },

    removeErrorMessage: function() {
      $(this.el)
        .children("#chatframe-error")
        .remove();
    },

    appendErrorMessage: function(error) {
      $(this.el).append("" +
        '<div id="chatframe-error" style="background-color: #ffc107; color: #000; padding: 1em; border: 1px solid #f00; border-radius: 5px;">' +
        '<p style="font-weight: bold;">' + i18n("EXPORT_ERROR") + ':</p>' +
        '<ul>' +
        '<li>Message:' + error.message + '</li>' +
        '<li>Status:' + error.status + '</li>' +
        '<li>Path:' + error.path + '</li>' +
        '</ul>' +
        '<p>' + i18n("chat_load_error_message") + '</p>' +
        '</div>' +
        "");
    },

    sendRetrivalOptionsToChatIframe: function() {
      if (this.hasIframe()) {
        var iframeWindow = this.$chatIframe.get(0).contentWindow;
        if (iframeWindow) {
          const messageData = JSON.stringify({ retrievalOptions: this.getRetrivalOptions() });
          iframeWindow.postMessage(messageData, "*");
        }
      }
    },

    setChatframeModel: function(modelId) {
      var modelID = modelId || this.options.modelId;
      if (this.hasIframe()) {
        var iframeWindow = this.$chatIframe.get(0).contentWindow;
        if (iframeWindow) {
          if (!modelID) {
            return;
          }
          const messageData = JSON.stringify({ chatframeModel: { id: modelID } });
          iframeWindow.postMessage(messageData, "*");
        }
      }
    },

    registerChatFrameListener: function() {
      var handleIframeMessages = this.handleIframeMessages.bind(this);
      window.addEventListener("message", handleIframeMessages, false);
    },

    /**
     *
     * @param {*} event
     * @returns
     *
     * event.data.message is a string with actual value e.x: "id:<uuid>"
     * event.data.type is a string which indicate message comes from chat-ui component
     */
    handleIframeMessages: function(event) {
      var data = event.data;
      if (data.type && data.message) {
        switch (data.type) {
          case "chatframe:loaded":
            this.sendRetrivalOptionsToChatIframe();
            this.setChatframeModel();
            this.resizeCallBack();
            break;
          case "chatframe:conversation:start":
            break;
          case "chatframe:conversation:stop":
            var messageParts = data.message.split(":");
            if (messageParts.length > 1) {
              // last conversation id
              var id = messageParts[1];
            }
            break;
          case "chatframe:modelchanged":
            var messageParts = data.message.split(":");
            if (messageParts.length > 1) {
              var modelId = messageParts[1];
                this.setChatframeModel(modelId);
                break;
            }
            break;
          default:
            break;
        }
      }
    },

    removeEventHandlers: function() {
      var handleIframeMessages = this.handleIframeMessages.bind(this);
      window.removeEventListener("message", handleIframeMessages, false);
      DataCollection.off();
      $(window).off("resize", this.resizeCallBack);
    },

    hasIframe: function() {
      var onEl = $(this.el).find("mb-chatiframe");
      return (this.$chatIframe && this.$chatIframe.length > 0) || onEl.length > 0;
    },

    getRetrivalOptions: function() {
      var asUrlParam = false;
      var constraint = this.constraint(asUrlParam);
      var searchRequest = this.getSearchRequest();
      if (searchRequest && constraint) {
        return { constraint: constraint, search_request: searchRequest };
      } else if (!searchRequest && constraint) {
        return { constraint: constraint };
      } else if (searchRequest && !constraint) {
        return { search_request: searchRequest };
      }
      return undefined;
    },


    getRetrivalOptionsAsUrlParam: function() {
      var retrievalOptions = this.getRetrivalOptions();
      if (!retrievalOptions) {
        return null;
      }
      return Lzma.compressUrlSafe(JSON.stringify(retrievalOptions));
    },

    constraint: function(asUrlParam) {
      var constraint = this.options.constraint;
      if (constraint && isNaN(constraint)) {
        if (asUrlParam) {
          if (constraint.unparsed) {
            asUrlParam.searchParams.set("retrieval_constraint_unparsed", constraint.unparsed);
            return asUrlParam;
          } else {
            asUrlParam.searchParams.set("retrieval_constraint", Lzma.compressUrlSafe(JSON.stringify(constraint)));
            return asUrlParam;
          }
        }
        return constraint;
      }
      return undefined;
    },

    getSearchRequest: function() {
      var searchRequest = this.model.input.toJSON();
      searchRequest = deepClone(searchRequest);
      if (searchRequest) {
        var options = this.options;
        var user = searchRequest.user;
        var source_context = searchRequest.source_context;

        function deletePropertyIfConditionMet(keepProperty, object, property) {
          if ((keepProperty === "false" || keepProperty === false) && object && object[property]) {
            delete object[property];
          }
        }

        deletePropertyIfConditionMet(options.useUserQuery, user, "query");
        deletePropertyIfConditionMet(options.useUserConstraints, user, "constraints");
        deletePropertyIfConditionMet(options.useSourceContextConstraints, source_context, "constraints");
      }
      return searchRequest;
    },

    setParamLanguage: function(url) {
      url.searchParams.set("language", (i18n && i18n.currentLocale()) || "en");
      return url;
    },

    setParamShowModelSetting: function(url) {
      var showModel = this.options.showModel;
      url.searchParams.set("show_model", showModel);
      return url;
    },

    setParamShowSideNavigationSetting: function(url) {
      var showSideNavigation = this.options.showSideNavigation;
      url.searchParams.set("show_side_navigation", showSideNavigation);
      return url;
    },

    getIframeSrc: function() {
      var defaultChannel = this.defaultChannel();
      return defaultChannel + "/apps/chat";
    }
  });

  TemplateRegistry.add({
    id: "chatframe",
    name: "editor_gen_ai",
    weight: 4,
    getAdders: function(model, application) {
      var sourceInfoUtil = new SourceInfoUtil(application.models.sourceInfo, application.channels);
      if (!sourceInfoUtil.isServiceAvailable("mindbreeze.chat.v1beta")) {
        return;
      }
      return [
        {
          name: "editor_chatframe",
          icon: "../img/chat.png",
          group: {
            name: "Chat"
          },
          options: {
            template: "chatframe",
            showModel: "true",
            showSideNavigation: "true",
            useUserQuery: "true",
            useUserConstraints: "true",
            useSourceContextConstraints: "true",
            height: "auto",
            constraint: "ALL"
          }
        },
        {
          name: "editor_answer_box",
          icon: "../img/answer.png",
          group: {
            name: "Chat"
          },
          options: {
            template: "answers",
            "no-default-template": true
          }
        }
      ];
    },

    create: function(options) {
      var schema = new Template.Schema();
      options = options || {};
      options.template = options.template;
      var el = document.createElement("div");
      _.forEach(options, function(value, key) {
        el.setAttribute("data-" + dom.AttributeModel.camelCaseToSeparated(key), schema.serializeAttribute(value, key));
      });

      return el;
    }
  });

  return ChatTemplate;
});
